export const OFFICES = {
  main: {
    label: 'Loadsmart Headquarters',
    address: '200 W. Jackson Blvd Suite 1600',
    city: 'Chicago',
    state: 'IL',
    zipcode: '60606',
  },
};
